import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            你可能想了解的一些事情
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl border border-background-200/70 overflow-hidden bg-background-50"
            >
              <div className="p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="font-label text-xs font-extrabold text-primary-700">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2">
                      {item.question}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}